export default __webpack_public_path__ + "locales/de/PDFFormDialog.json?hash=b39b683bb28c3ef43a7fb83c4bc18d90";